module.exports = __webpack_public_path__ + "img/backgroundFifth.afd419c0.png";